export default {
  banksPage: {
    nothingFound: 'Mitään ei löytynyt. Tarkista ilmoituksesi.',
    bankInCountry: 'Valitse pankkisi '
  }
}
